import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { AddCustomerHeadReducer } from './Reducer/CustomerHeadReducer'

const reducer = combineReducers({
    addCustomerHeadData: AddCustomerHeadReducer
})

const initialState = {

}

const middleware = [thunk]

const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
)

export default store;